import { Component, Input, output, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeadingComponent, IconComponent } from '@core/user-interface-legacy';

import type { FileDropAreaType } from '../../services/attachment-upload.service';
import { AttachmentUploadService } from '../../services/attachment-upload.service';

@Component({
  selector: 'rt-files-drop-area',
  templateUrl: './files-drop-area.component.html',
  styleUrls: ['./files-drop-area.component.less'],
  imports: [HeadingComponent, IconComponent, TranslatePipe],
  host: {
    '(drop)': 'onDrop($event)',
    '(dragover)': 'onDragOver($event)',
    '(dragleave)': 'onDragLeave($event)',
  },
})
export class FilesDropAreaComponent {
  private readonly attachmentUploadService = inject(AttachmentUploadService);

  @Input() public targetId: string | number;
  @Input() public type: FileDropAreaType;
  public filesDrop = output<boolean>();
  public areaLeave = output<boolean>();

  public onDragOver($event: DragEvent): void {
    this.preventAndStop($event);
  }

  public onDrop($event: DragEvent): void {
    this.preventAndStop($event);
    this.attachmentUploadService.addToQueue($event, this.targetId, this.type);
    this.attachmentUploadService.startUpload();
    this.filesDrop.emit(true);
  }

  public onDragLeave($event: DragEvent): void {
    this.preventAndStop($event);
    this.areaLeave.emit(true);
  }

  private preventAndStop($event: DragEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
